<template>
  <div id="callback-page" class="container-fluid container h-100">
    <the-overlay :active="!$route.query.error && !err" :showSpinner="true">

      <error-group
        :title="errorTitle"
        :summary="errorSummary"
        :message="errorDetails"
        v-if="$route.query.error || err" />

    </the-overlay>
  </div>
</template>

<script lang="ts">
import userManager from '@/components/oidc';
import TheOverlay from '@/components/ui/TheOverlay.vue';
import ErrorGroup from '@/components/ui/ErrorGroup.vue';
import { defineComponent } from 'vue';
import { Logger } from 'oidc-client-ts';
import { mapActions } from 'pinia';
import useAppStore from '@/components/store';

export default defineComponent({
  name: 'OpenIdConnectCallback',
  components: { TheOverlay, ErrorGroup },
  data() {
    return {
      err: '',
    };
  },
  computed: {
    errorTitle(): string {
      if (this.$route.query.error) return 'Oauth error';
      return 'Token endpoint error';
    },
    errorSummary(): string {
      if (this.$route.query.error) return this.$route.query.error as string;
      return '';
    },
    errorDetails(): string {
      if (this.$route.query.error) return this.$route.query.error_description as string;
      return this.err;
    },
  },
  methods: {
    ...mapActions(useAppStore, ['setPrincipal']),
  },

  mounted() {
    Logger.info('oidc:callback', 'processing callback...');

    userManager.signinRedirectCallback().then((user) => {
      window.tokenChecked = true;

      // save principal in store
      // this.setPrincipal(user);
      // userManager.events.addUserLoaded(this.setPrincipal); // register for addUserLoaded event

      const gotoPage = user.state as string;
      Logger.info(
        'oidc:callback',
        `welcome <${user.profile.given_name}> [${user.profile.admin_roles}], redirecting you to ${gotoPage}...`,
      );
      this.$router.push(gotoPage || '/');
    }).catch((oauth_error) => {
      Logger.error('oidc:callback', `Failed to get token: ${oauth_error}`);
      this.err = oauth_error; // usually "No matching state found in storage"
    });
  },
});
</script>
